import { useReadAloud as useQCLReadAloud } from '@3plearning/question-components-library';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Resources from '../../../helpers/resources';

export const useReadAloud = () => {
  const [readAloudConfig, setReadAloudConfig] = useState({
    enabled: false,
    gatewayUrl: window._env_.ReadAloudGatewayUrl,
    token: Resources.env.authToken,
    locale: 'en-AU'
  });

  const onLocaleChange = (locale) => {
    setReadAloudConfig({
      ...readAloudConfig,
      locale
    });
  };

  const { locale: localeFromQueryString } = useSelector(state => state.queryStringReducer);
  const { setReadAloudConfig: setQCLReadAloudConfig, setTranscriptModalInitialPosition } = useQCLReadAloud();

  useEffect(() => {
    const defaultLocale = localeFromQueryString || 'en-AU';
    const locale = /es-/ig.test(defaultLocale) ? 'es-US' : defaultLocale;

    setQCLReadAloudConfig(prevConfig => ({
      ...prevConfig,
      locale
    }));

    setTranscriptModalInitialPosition({
      left: Math.max(window.innerWidth - 540, 0),
      top: 75
    });
  }, [localeFromQueryString]);

  return { readAloudConfig, onLocaleChange };
};
